/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-03 15:34:38
 * @LastEditors: K
 * @LastEditTime: 2022-09-07 16:01:25
 */
import {Col, notification} from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { TabBar, TabPane } from '../../compnents/widgets/TabBar';
import { AddServicesPage } from './addServices/addServicesPage';
import { AnalysisRecordPage } from './analysisRecordPage/analysisRecordPage';
import { MonitoringPage } from './monitoringPage/monitoringPage';
import styles from './monitoringTab.module.css'
import { OrganizationData } from './organizationData/organizationData';
import { OutpatientData } from './outpatientData/outpatientData';
import { UseDetailPage } from './useDetail/useDetailPage';
import { UserData } from './userData/UserData';
import moment from "moment";
import {DateTimeFormat} from "../../models/datetime";

export const MonitoringTab = (): ReactElement => {
  const location: any = useLocation()

  const [showFlag, setshowFlag] = useState(false)

  const [selectedTab, setSelectedTab] = useState('0')

  const storageParams = JSON.parse(sessionStorage.getItem(location.pathname) || '{}')

  useEffect(() => {
    setSelectedTab(location?.state?.station || storageParams.state)
  }, [location?.state])

  useEffect(() => {
    const now = moment().format('HH:mm:ss');
    console.log(now)
    const hour= Number(now.split(":")?.[0]);
    if((hour>=7 && hour<=11) || (hour >=13 && hour <=16)){
      setshowFlag(true);
      notification.error({ message: "仅在非业务高峰期可以查询（12:00~12:59,17:00~06:59）", duration: 3 });
    }
  }, [])


  return (
    <>
      <Col className={styles.container} hidden={showFlag}>
        <TabBar

          activeKey={selectedTab}
          destroyInactiveTabPane
          onChange={(v) => {
            setSelectedTab(v)
          }}
        >
          <TabPane key='0' tab='his数据总览'>
            <MonitoringPage state={selectedTab} />
          </TabPane>
          <TabPane key='1' tab='机构数据'>
            <OrganizationData state={selectedTab} />
          </TabPane>
          <TabPane key='2' tab='用户数据'>
            <UserData state={selectedTab} />
          </TabPane>
          <TabPane key='3' tab='门诊数据'>
            <OutpatientData state={selectedTab} />
          </TabPane>
          <TabPane key='4' tab='增值服务'>
            <AddServicesPage state={selectedTab} />
          </TabPane>
          <TabPane key='5' tab='使用详情'>
            <UseDetailPage state={selectedTab} />
          </TabPane>
          {/* <TabPane key='2' tab='分析记录'>
            <AnalysisRecordPage />
          </TabPane> */}

        </TabBar>
      </Col>
    </>
  );
}

